import {NODETYPE} from "./vnode";
import {concat} from "../core/collections";
import {flattenChildren} from "./util";
import {deepClone, deepMerge} from "../core/collections";

export class View {
    static $type = NODETYPE.VIEW
    constructor(opt={}, construct=opt) {
        this.$name = this.constructor.name
        this.isView = true
        this.$constructor = construct
        let cons = Object.getOwnPropertyNames(this.$constructor)
        for (let i = 0; i < cons.length; i++) {
            const prop = cons[i]
            if (prop instanceof Function)
                this[prop] = this.$constructor[prop]
            else
                this[prop] = deepClone(this.$constructor[prop])
        }
        //
        // concat(this, deepClone(this.$constructor), true)
    }

    static create(name, opt) {
        let c = new View(opt)
        c.$name = name
    }

    createInstance(props, children) {
        const construct = this.$constructor
        const name = this.$name
        let inst = new View(construct, construct)
        inst.$name = name
        return inst.updateInstance(props, children)
    }

    updateInstance(props, children) {
        if (children)
            children = flattenChildren(children)
        if (!this.props) this.props = {}
        if (props)
            concat(this.props, props, true)
        this.children = children
        return this
    }
}

global.View = View